/* @flow */

import React, { Component } from 'react';
import cx from 'classnames';

type Props = {
  isSubmitting: boolean,
  onSubmit: (name: string) => void,
};

type State = {
  name: string,
};

class NewFolder extends Component {
  props: Props;
  state: State;

  static defaultProps = {
    isSubmitting: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      name: '',
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    // Clearing component if submitted successfully
    if (this.props.isSubmitting && !nextProps.isSubmitting) {
      this.setState({
        name: '',
      });
    }
  }

  onChange = (event: SyntheticEvent) => {
    if (event.target instanceof HTMLInputElement) {
      this.setState({
        name: event.target.value,
      });
    }
  };

  onSubmit = () => {
    const { name } = this.state;
    const { onSubmit } = this.props;

    if (name) {
      onSubmit(name);
    }
  };

  render() {
    const { isSubmitting } = this.props;
    const { name } = this.state;

    const buttonClass = cx(
      'ui right floated fluid primary labeled icon button',
      {
        disabled: name.length < 1,
        loading: isSubmitting,
      }
    );

    return (
      <div className="ui fluid card">
        <div className="content">
          <div className="header">Créer un nouveau dossier</div>
        </div>
        <div className="content">
          <div className="ui form">
            <div className="inline fields">
              <div className="twelve wide field">
                <label>Nom</label>
                <input type="text" value={name} onChange={this.onChange} />
              </div>
              <div className="four wide field">
                <button className={buttonClass} onClick={this.onSubmit}>
                  <i className="add icon" />
                  Ajouter
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewFolder;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folders/components/NewFolder.js